import { Divider, IconButton, InputAdornment, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material";
import { ArrowUp02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { cashOptions } from "@/constants/paymentMethods";
import { addCurrency } from "@/utils/numbers";
import Price from "@/components/Price";

interface CashDetailsProps {
  total: number;
  amount: number | "";
  onAmountChange: (amount: number | "") => void;
}

const CashDetails = ({ total, amount, onAmountChange }: CashDetailsProps) => {
  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2} p={2}>
        <div>
          <IconButton sx={{ backgroundColor: "#015FEE" }}>
            <HugeiconsIcon icon={ArrowUp02Icon} color="white" />
          </IconButton>
        </div>

        <Stack>
          <Typography variant="h3" fontWeight={600}>
            <Price currency="NIO">{total}</Price>
          </Typography>
          <Typography variant="body1">Total a pagar</Typography>
        </Stack>
      </Stack>

      <Divider />

      <Stack p={2} spacing={2}>
        <Typography variant="h4" textAlign="center">
          ¿Con cuánto desea cancelar?
        </Typography>

        <RadioGroup value={amount === "" ? "" : amount} onChange={(e) => onAmountChange(Number(e.target.value))}>
          <Stack
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "repeat(2, 1fr)",
              },
              gap: 2,
              width: "100%",
            }}
          >
            {cashOptions
              .filter((c) => c.value >= total)
              .map((c) => (
                <TextField
                  key={c.value}
                  value={addCurrency(c.value, "NIO", 0)}
                  size="small"
                  fullWidth
                  slotProps={{
                    input: {
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <Radio value={c.value} />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              ))}

            <TextField
              value="Monto exacto"
              size="small"
              slotProps={{
                input: {
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <Radio value={total} />
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Stack>
        </RadioGroup>

        <TextField
          label="Monto"
          type="number"
          size="small"
          value={amount}
          onChange={(e) => {
            const raw = e.target.value;
            onAmountChange(raw === "" ? "" : Number(raw));
          }}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">C$</InputAdornment>,
            },
          }}
          fullWidth
        />
      </Stack>
    </Stack>
  );
};

export default CashDetails;
